import React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import { Config, ConfigProvider } from 'root/apps/contexts/ConfigContext';
import { UserPreference, UserPreferencesProvider } from 'root/apps/contexts/UserPreferencesContext';
import { PartitionCollapseToggleView } from 'root/apps/Partition/PartitionCollapseToggle/PartitionCollapseToggleView';

export interface PartitionCollapseToggleConfig extends Config {
  partitionName: string;
  title?: string;
  userPreferenceName?: string;
}

interface PartitionCollapseToggleProps {
  config: PartitionCollapseToggleConfig;
  userPreferences?: UserPreference[];
}

const PartitionCollapseToggle: React.FC<PartitionCollapseToggleProps> = ({
  config,
  userPreferences,
}) => {
  return (
    <ConfigProvider config={config}>
      <UserPreferencesProvider userPreferences={userPreferences}>
        <PartitionCollapseToggleView />
      </UserPreferencesProvider>
    </ConfigProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: PartitionCollapseToggle,
  selector: '[data-react-root="PartitionCollapseToggle"]',
});

history.onChangeState(
  [
    {
      name: undefined,
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
